import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {ToastrService} from "ngx-toastr";
import {VoceProgetto} from "../../Models/VoceProgetto";

@Component({
  selector: 'app-destinazione-voci-list',
  templateUrl: './destinazione-voci-list.component.html',
  styleUrls: ['./destinazione-voci-list.component.css']
})
export class DestinazioneVociListComponent implements OnInit {
  @Input() items: VoceProgetto[] = [];
  @Output() AddClick = new EventEmitter();
  @Input() isModal: boolean = true;
  constructor(
    private ngbActiveModal: NgbActiveModal,
    private toastrService: ToastrService
  ) { }

  ngOnInit(): void {
  }

  Add(item: VoceProgetto){
    item.voce_id = item.id;
    if(item?.quantita <= item.disponibilita ) {
      this.AddClick.emit(item);
      item.disponibilita = item?.disponibilita - item?.quantita;
    }
    else
      this.toastrService.warning("La quantità non può essere maggiore della disponibilità")
  }
  close() {
    this.ngbActiveModal.dismiss();
  }
}
